import EtatBadge from "./EtatBadge";


const formatDateFR = (dateISO) => {
  if (!dateISO) return "";

  const [y, m, d] = dateISO.split("T")[0].split("-");

  return `${d}/${m}/${y}`;
};



const formatHeure = (heure) => {
  if (!heure) return "";

  return heure.substring(0, 5);
};



const calculerHeures = (heureDebut, heureFin) => {

  if (!heureDebut || !heureFin) return 0;


  const [h1, m1] = heureDebut.split(":").map(Number);
  const [h2, m2] = heureFin.split(":").map(Number);


  const debut = h1 * 60 + m1;
  const fin = h2 * 60 + m2;


  if (fin <= debut) return 0;


  return ((fin - debut) / 60).toFixed(2);

};



const RendezVousTable = ({
  data,
  onEdit,
  onDelete,
  onEditHeureFin,
  entretiens,
  clients,
  onChangeEtat,
}) => {


  return (

    <table className="responsive-table">

      <thead>

        <tr>
          <th>Technicien</th>
          <th>Date</th>
          <th>Heure début</th>
          <th>Type entretien</th>
          <th>Client</th>
          <th>Note</th>
          <th>État</th>
          <th>Remarque tech</th>
          <th>Heure fin</th>
          <th>NB Heure</th>
          <th>Actions</th>
        </tr>

      </thead>



      <tbody>

        {
          data.map((rv) => (

            <tr key={rv.id}>


              <td data-label="Technicien">
                {rv.technicien || "-"}
              </td>



              <td data-label="Date">
                {formatDateFR(rv.date_rdv)}
              </td>



              <td data-label="Heure début">
                {formatHeure(rv.heure_debut)}
              </td>



              <td data-label="Type entretien">

                {
                  entretiens.find(
                    (t) => t.id === rv.type_entretien_id
                  )?.nom || "-"
                }

              </td>



              <td data-label="Client">

                {
                  clients?.find(
                    (c) => c.id === rv.client_id
                  )?.nom
                  ||
                  rv.client
                  ||
                  "-"
                }

              </td>



              <td data-label="Note">
                {rv.note || "—"}
              </td>



              <td data-label="État">

                {
                  rv.etat_travaux === "TERMINE"

                  ?

                  <EtatBadge 
                    etat={rv.etat_travaux}
                  />

                  :

                  <select

                    value={rv.etat_travaux}

                    onChange={(e)=>
                      onChangeEtat(
                        rv.id,
                        e.target.value
                      )
                    }

                  >

                    <option value="EN_ATTENTE">
                      En attente
                    </option>


                    <option value="EN_COURS">
                      En cours
                    </option>


                    <option value="TERMINE">
                      Terminé
                    </option>


                  </select>

                }

              </td>




              <td data-label="Remarque Technicien">

                {rv.remarque || "-"}

              </td>





              <td data-label="Heure fin">


                {
                  rv.etat_travaux === "TERMINE"

                  ?

                  <input

                    type="time"

                    value={
                      formatHeure(rv.heure_fin) || ""
                    }

                    onChange={(e)=>
                      onEditHeureFin(
                        rv.id,
                        e.target.value
                      )
                    }

                  />

                  :

                  formatHeure(rv.heure_fin)

                }


              </td>





              <td data-label="NB Heure">


                {
                  rv.heure_fin

                  ?

                  calculerHeures(
                    rv.heure_debut,
                    rv.heure_fin
                  )
                  + " h"

                  :

                  "-"

                }


              </td>





              <td data-label="Actions">


                <button
                  onClick={() => onEdit(rv)}
                >
                  ✏️
                </button>



                <button
                  onClick={() => onDelete(rv.id)}
                >
                  🗑
                </button>


              </td>



            </tr>


          ))
        }


      </tbody>


    </table>

  );

};


export default RendezVousTable;